import * as employerProfile from './employer-profile'
import * as general from './general'

export const userFormHelper = {
  employerProfile,
  general,
}
